var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xuwp40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.0203 18.2286C65.5439 29.5713 63.878 46.1231 50.8716 56.3201C37.8907 66.4972 19.6021 64.9364 8.29261 52.7868C-2.66485 41.0158 -2.79214 22.5722 8.04798 10.5067C19.0774 -1.77245 36.5546 -2.86941 48.4795 5.03293C46.9343 6.47525 45.389 7.91868 43.8924 9.31673C42.345 8.69574 40.8429 7.99285 39.2799 7.48255C25.4488 2.96962 10.5895 11.1797 7.01079 25.2808C3.58485 38.7809 11.8104 52.5997 25.2961 56.0046C39.2887 59.5368 53.4651 50.5984 56.3321 36.422C57.1623 32.3198 56.9697 28.2551 55.7399 24.2514C55.6126 23.8374 55.648 23.544 55.9302 23.2098C57.2397 21.6645 58.526 20.0993 59.8189 18.5396C59.8886 18.4544 59.9395 18.3537 60.0192 18.2297L60.0203 18.2286Z",
    fill: "#FF7351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.5065 35.8032C30.7954 35.356 31.0334 34.9874 31.2714 34.6188C38.1232 24.0488 46.3178 14.6289 55.6149 6.1498C56.4672 5.37274 57.3915 4.87905 58.5615 5.14029C59.7083 5.39599 60.5042 6.09999 60.8362 7.24013C61.1606 8.35369 60.9015 9.35657 60.099 10.1967C59.6795 10.6351 59.2157 11.0313 58.784 11.4586C51.6399 18.5363 45.3426 26.3058 39.9452 34.7871C37.9517 37.9197 36.1474 41.174 34.2977 44.3963C32.8321 46.95 29.4704 47.1448 27.8222 44.7095C24.2933 39.4981 20.7799 34.2746 17.2688 29.051C16.2836 27.5843 16.5282 25.8287 17.8233 24.8568C19.1981 23.8252 20.9891 24.0798 22.1403 25.4933C24.7781 28.7355 27.406 31.9854 30.0371 35.2332C30.1744 35.4025 30.3139 35.5697 30.5065 35.8032Z",
    fill: "#FF7351"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0a64a7729dc0d02ee9800bf3dfda6f26.svg";
export { ForwardRef as ReactComponent };